var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .cls-1,.cls-2{fill:none;stroke:#282828;stroke-miterlimit:10;stroke-width:2px;}.cls-2{stroke-linecap:round;}\n        ")),React.createElement("circle",{"cx":"14.14","cy":"14.14","r":"7.89","stroke":"currentColor","className":"cls-1","key":1}),React.createElement("line",{"x1":"19.93","x2":"25.76","y1":"19.93","y2":"25.76","stroke":"currentColor","className":"cls-2","key":2})]);
}

Search.defaultProps = {"aria-hidden":"true","className":"search-icon","viewBox":"0 0 32 32"};

module.exports = Search;

Search.default = Search;
